import {
  PLAYWRIGHT_POINTS_S2_CLAIM_KEY,
  PLAYWRIGHT_POINTS_SEASON3_ACTIVE_KEY,
  PLAYWRIGHT_PROMPT_DELEGATE_AFTER_STAKE_KEY,
  PLAYWRIGHT_SEASON_1_POINTS_CLAIMABLE_KEY,
  PLAYWRIGHT_SPARK_VAULTS_V2_ENABLED_KEY,
  PLAYWRIGHT_SPARK_VAULTS_V2_PYUSD_ENABLED_KEY,
  PLAYWRIGHT_STUSDS_ACCOUNT_ENABLED_KEY,
  PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE_KEY,
  PLAYWRIGHT_TOS_ON_CONNECT_WALLET,
} from '../wagmi/e2e-consts'

const IS_NOT_PLAYWRIGHT = import.meta.env.VITE_PLAYWRIGHT !== '1'

const PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE = (window as any)[PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE_KEY] === true
export const USDC_ACCOUNT_ENABLED = PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE || IS_NOT_PLAYWRIGHT

export const TOS_ON_CONNECT_WALLET =
  import.meta.env.VITE_FEATURE_TOS_ON_CONNECT_WALLET === '1' ||
  (window as any)[PLAYWRIGHT_TOS_ON_CONNECT_WALLET] === true

export const SEASON_1_POINTS_CLAIMABLE =
  import.meta.env.VITE_FEATURE_SEASON_1_POINTS_CLAIMABLE === '1' ||
  (window as any)[PLAYWRIGHT_SEASON_1_POINTS_CLAIMABLE_KEY] === true

export const PROMPT_DELEGATE_AFTER_STAKE =
  import.meta.env.VITE_FEATURE_PROMPT_DELEGATE_AFTER_STAKE === '1' ||
  (window as any)[PLAYWRIGHT_PROMPT_DELEGATE_AFTER_STAKE_KEY] === true

export const STUSDS_ACCOUNT_ENABLED =
  import.meta.env.VITE_FEATURE_STUSDS_ACCOUNT === '1' || (window as any)[PLAYWRIGHT_STUSDS_ACCOUNT_ENABLED_KEY] === true

export const SPARK_VAULTS_V2_ENABLED =
  import.meta.env.VITE_FEATURE_SPARK_VAULTS_V2 === '1' ||
  (window as any)[PLAYWRIGHT_SPARK_VAULTS_V2_ENABLED_KEY] === true

export const SPARK_VAULTS_V2_PYUSD_ENABLED =
  import.meta.env.VITE_FEATURE_SPARK_VAULTS_V2_PYUSD === '1' ||
  (window as any)[PLAYWRIGHT_SPARK_VAULTS_V2_PYUSD_ENABLED_KEY] === true

export const POINTS_S2_CLAIM_ENABLED =
  import.meta.env.VITE_FEATURE_POINTS_S2_CLAIM === '1' || (window as any)[PLAYWRIGHT_POINTS_S2_CLAIM_KEY] === true

export const POINTS_SEASON3_ACTIVE =
  import.meta.env.VITE_POINTS_SEASON_3_ACTIVE === '1' || (window as any)[PLAYWRIGHT_POINTS_SEASON3_ACTIVE_KEY] === true
